import { Center } from "@chakra-ui/layout";
import { Spinner } from "@chakra-ui/spinner";
import {
  LargeSelect,
  type LargeSelectProps,
} from "@src/components/ui-kit/Select/LargeSelect";
import { contractorOptionsQuery } from "@src/utils/components/filters/paginatedOptions";
import { fieldToSelectProps } from "@src/utils/forms/inputHelpers";
import type { FieldState } from "formstate";
import { observer } from "mobx-react-lite";
import type { FunctionComponent } from "react";

interface Props
  extends Omit<LargeSelectProps, "value" | "onChange" | "error" | "options"> {
  waitForDefaultName: boolean;
  defaultName: string | undefined | null;
  field: FieldState<string>;
}

export const ContractorSelect: FunctionComponent<Props> = observer(
  function ContractorSelect({
    defaultName,
    field,
    waitForDefaultName,
    ...props
  }) {
    return waitForDefaultName && !defaultName ? (
      <Center>
        <Spinner />
      </Center>
    ) : (
      <LargeSelect
        loadOptions={async (page, perPage, searchPhrase) => {
          const { options, paginatorInfo } = await contractorOptionsQuery({
            page: page,
            first: perPage,
            filters: {
              search: searchPhrase,
            },
          });

          return {
            data: options,
            paginatorInfo: paginatorInfo,
          };
        }}
        defaultInputValue={defaultName ?? undefined}
        isClearable
        {...fieldToSelectProps(
          field,
          defaultName ? [{ label: defaultName, value: field.$ }] : [],
        )}
        {...props}
      />
    );
  },
);
